<!-- @format -->

<hmf-drawer
	id="reviews-information-drawer"
	className="reviews-information-modal"
	[direction]="isMobileSize ? 'bottom' : 'right'"
	[closable]="true"
	[trapFocus]="true"
	[searchShadowRootFocus]="reviewDrawerType === drawerTypeOptions.QUESTIONS"
	[isCloseButtonSticky]="true"
	[headerText]="drawerTitle"
	[mobilePeek]="isMobileSize"
	(closed)="closeDrawer()"
	(keydown)="activeKeydownEvent($event)">
	<div class="review-drawer-content-container">
		<ng-container *ngIf="reviewDrawerType === drawerTypeOptions.REVIEWS; else questionView">
			<product-reviews-drawer-container
				[isFirstPanelOpen]="isFirstPanelOpen"></product-reviews-drawer-container>
		</ng-container>
		<ng-template #questionView>
			<ng-container *ngIf="reviewDrawerType === drawerTypeOptions.QUESTIONS">
				<product-reviews-questions-answers></product-reviews-questions-answers>
			</ng-container>
		</ng-template>
	</div>
</hmf-drawer>
